import React from 'react';
import { FormState, UseFormRegister } from 'react-hook-form';
import { IProjeto } from '../hooks/Model/Projeto/type';
import { InputField } from '../styles/InputField';
import { Errors } from './Erro';

type INameField = {
    register: UseFormRegister<any>
    formState: FormState<any>
    placeholder?: string
}

export function ObjetivoField({ register, formState, placeholder }:INameField) {
  return (
    <InputField>
      <label htmlFor="">Objetivo:</label>
      <div className="flex-column">
        <textarea
          autoComplete="off"
          {...register("objetivo", { required: true })}
          className="form-control form-control-lg"
          placeholder={placeholder}
          required
        />
        {formState.errors.objetivo && (
        <Errors />
        )}
      </div>
    </InputField>
  );
}
